import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { ReportCertidaoCancelamentoPjRequest, ReportCertidaoCancelamentoPjResponse, ReportJobCreatedResponse, ReportJobStatusResponse } from './certidao-cancelamento-pj.model';

/** Cliente HTTP do relatório assíncrono Certidão de Cancelamento PJ. */
@Injectable({ providedIn: 'root' })
export class CertidaoCancelamentoPjService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.prestador.reports.certidaoCancelamentoPj;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    exportarPdf(request: ReportCertidaoCancelamentoPjRequest): Observable<HttpResponse<ReportCertidaoCancelamentoPjResponse | ReportJobCreatedResponse>> {
        return this.http.post<ReportCertidaoCancelamentoPjResponse | ReportJobCreatedResponse>(`${this.PATH}/exportar-pdf`, request, { observe: 'response' });
    }

    iniciarGeracaoAssincrona(request: ReportCertidaoCancelamentoPjRequest): Observable<ReportJobCreatedResponse> {
        return this.http.post<ReportJobCreatedResponse>(`${this.PATH}/exportar-pdf-async`, request);
    }

    consultarStatus(jobId: string): Observable<ReportJobStatusResponse> {
        return this.http.get<ReportJobStatusResponse>(`${this.PATH}/job/${jobId}/status`);
    }

    baixarPdf(jobId: string): Observable<ArrayBuffer> {
        return this.http.get(`${this.PATH}/job/${jobId}/download`, { responseType: 'arraybuffer' });
    }
}
